import { Button, Group, Modal, Stack, Text } from '@mantine/core';

interface DeleteReportConfigModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  configName: string;
}

export function DeleteReportConfigModal({
  opened,
  onClose,
  onConfirm,
  configName,
}: Readonly<DeleteReportConfigModalProps>) {
  return (
    <Modal opened={opened} onClose={onClose} title="Delete Configuration" size="sm">
      <Stack>
        <Text>
          Are you sure you want to delete{' '}
          <Text span fw={700}>
            {configName}
          </Text>
          ? This action cannot be undone.
        </Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button color="red" onClick={onConfirm}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
